// ? trying to have the same as CRA
// import '../../Styles/css/month.css';
// import '../../Styles/css/Modal.css';

import PropTypes from 'prop-types';
import React from 'react';

import useCraRdv from '../../hooks/useCraRdv';
import DayCalendrier from './DayCalendrier';
export default function MonthCalendrier({ evts}) {

    MonthCalendrier.propTypes = {
        evts: PropTypes.any,
    };
    const {calendarMonthMatrix} = useCraRdv();

    return (
        <div
            // className="flex-1 grid grid-cols-7 grid-rows-5"
            style={{
                display: 'grid',
                flex: '1 1 0%',
                gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                gridGap:'1.5px',
                height: 'fit-content',
                //gridTemplateRows:'repeat(5, minmax(100%, 1fr))',
                // * old
                //background:'white',
                alignSelf:'stretch',
                //border: '1px solid #C3C9F1',
                //width: '1125px',
                // height: '752px'
            }}
        >
            {calendarMonthMatrix.map((row, i) => (
                <React.Fragment key={i}>
                    {row.map((day, j) => (
                        <DayCalendrier
                            key={j}
                            day={day}
                            evts={evts}
                            rowIdx={i}
                        />
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
}
